import { useQuery } from "react-query";
import { getVendors } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetVendors = () => {
  return useQuery("GetVendors", getVendors, {
    refetchOnWindowFocus: false,
  });
};
